import { getStorageUserToken } from 'helpers/ticketSales';
import callAPiBase from './base';
import callAPiPublicBase from './publicBase';
import callAPiBaseTo3DsAuth from './baseApiTo3DsAuth';

const itinerariesApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/itineraryList',
      method: 'GET',
      useToken: true,
      title: 'Itineraries - Get List',
      params,
    }),
  listByWeekday: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/itineraryListByWeekday',
      method: 'GET',
      useToken: true,
      title: 'Itineraries - Get List',
      params,
    }),
  get: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/itineraryList',
      method: 'GET',
      useToken: true,
      title: 'Itinerary - Get',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/itineraryCreate',
      method: 'POST',
      useToken: true,
      title: 'Itinerary - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/itineraryUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Itinerary - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/itineraryDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Itinerary - Delete',
      params,
    }),
  resume: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/itineraryResume',
      method: 'POST',
      useToken: true,
      title: 'Itinerary - Resume',
      data,
    }),
  stopDepartures: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/stopDeparturesFree',
      method: 'GET',
      useToken: true,
      title: 'Stop - Departures',
      params,
    }),
  getTripCapacity: ({ params }: { params?: object }) =>
    callAPiPublicBase({
      endpoint: '/trip',
      useToken: true,
      method: 'GET',
      title: 'Itinerary Trip Capacity - Get',
      params,
    }),

  get3DsToken: ({ data }: { data: object }) =>
    callAPiBaseTo3DsAuth({
      endpoint: '/payment3DSAuth/authAPI',
      method: 'POST',
      useToken: true,
      title: 'Card - Get',
      data,
      headers: { Authorization: getStorageUserToken() },
    }),
  pedestrianTokens: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserBookPedestrianTokens',
      method: 'POST',
      useToken: true,
      title: 'Pedestrian - Tokens',
      data,
      headers: { Authorization: getStorageUserToken() },
    }),

  vehicleTokens: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserBookVehicleTokens',
      method: 'POST',
      useToken: true,
      title: 'Vehicle - Tokens',
      data,
      headers: { Authorization: getStorageUserToken() },
    }),
  rescheduleToken: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserRescheduleToken',
      method: 'POST',
      useToken: true,
      title: 'Reschedule - Tokens',
      data,
      headers: { Authorization: getStorageUserToken() },
    }),

  seatPreReserve: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/seatPreReserve',
      method: 'POST',
      useToken: true,
      title: 'Seat - Pre Reserve',
      data,
      headers: { Authorization: getStorageUserToken() },
    }),

  getVehicleLicense: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/appUserFindVehicle',
      useToken: true,
      method: 'GET',
      title: 'Itinerary appUserFindVehicle - Get',
      params,
    }),
  bpeDabpePdf: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/bpeDabpePdf',
      useToken: true,
      method: 'GET',
      title: 'bpeDabpePdf - Get',
      params,
    }),
  tokenList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/tokenList',
      method: 'GET',
      useToken: true,
      title: 'Tokens - List',
      params,
    }),
  userTransactionList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/userTransactionList',
      method: 'GET',
      useToken: true,
      title: 'Tokens - List',
      params,
    }),
  cancelBookedToken: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserCancelBookedToken',
      method: 'POST',
      useToken: true,
      title: 'Cancel Booked Token',
      data,
    }),
  appUserListBpe: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserListBpe',
      method: 'GET',
      useToken: true,
      title: 'Bpe - List',
      params,
    }),
};

export { itinerariesApi };
export default itinerariesApi;
